import React from 'react';
import { ModuleInterface } from '_iae/module/module';
import { NavItem } from 're-cy-cle';
import { t } from 'i18next';
import { SprintPlanningScreen } from './Screen';

export const sprintPlanningModule: ModuleInterface = {
    name: 'sprintPlanning',
    navigationMenu: () => ({
        basePath: '/planning/sprint-planning/',
        topMenuItem: (
            <NavItem
                title={t('nav.main.sprintPlanning', 'Sprint Planning')}
                to="/planning/sprint-planning"
                activePath="/planning/sprint-planning"
                data-test-nav="sprint-planning"
            />
        ),
        subMenuItems: []
    }),
    routes: [
        {
            path: '/planning/sprint-planning',
            screen: SprintPlanningScreen
        }
    ],
    translations: {
        en: {},
        nl: {}
    }
};
